import React, { useContext, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { NavSearchContext } from '../../context/NavSearchContext';
import { SearchBarVariant } from '../NavSearchElements/searchUtils';

export interface AutoSuggestDropdownProps {
    show?: boolean;
    className?: string;
    useNewSearchUI?: boolean;
}

const searchBarVariantStyle = {
    [SearchBarVariant.ProminentSearch]:
        'flex w-max bg-white rounded-3xl text-gray-900 absolute left-0 p-6 top-full z-50 mt-5 border border-gray-400 border-solid',
    [SearchBarVariant.ProminentSearchHistoryExperiment]:
        'flex w-max bg-white rounded-3xl text-gray-900 absolute left-0 p-6 top-full z-50 mt-5 border border-gray-400 border-solid mt-4 -ml-5 lg:w-[720px] md:w-[500px]',
};

const AutoSuggestDropdown = ({
    className = '',
    show = false,
    children,
    useNewSearchUI,
    ...rest
}: PropsWithChildren<AutoSuggestDropdownProps>) => {
    const context = useContext(NavSearchContext);
    const { searchBarVariant } = context;
    return (
        show && (
            <div
                role="button"
                tabIndex={0}
                className={twMerge(
                    searchBarVariantStyle[searchBarVariant] ??
                        'flex bg-white rounded-b text-gray-900 shadow-dropdown absolute left-0 pb-1.5 top-full z-50',
                    className,
                )}
                onMouseDown={(e) => e.preventDefault()}
                {...rest}
            >
                {children}
            </div>
        )
    );
};

export default AutoSuggestDropdown;
